module.exports = __webpack_public_path__ + "img/车享配.png";